import _ from "underscore";

/**
 * Invoca internal inline editor for backdraft
 */

import ExceptionHandling from "shared/logging/exception_handling";
import Ajax from "shared/ajax";

import "./help_popover";
import $ from "jquery";

$.fn.inlineEdit = function(model, options) {
  // Config
  var element    = $(this);
  var errors     = $('<span data-mount="errors" class="sb-field-invalid-feedback"></span>');
  var isInput    = element[0] && element[0].tagName === "INPUT";
  var editTag    = isInput ? "input" : "textarea";

  var attrs = {
    cols:      element.attr('cols') || 195,
    rows:      element.attr('rows') || 5,
    maxlength: element.attr('maxlength') || 255
  };
  var textareaDimensions = isInput ? "" : " cols='" + attrs.cols + "' rows='" + attrs.rows + "' maxlength='" + attrs.maxlength + "'";

  // Parent span tag
  var parent = $('<span class="ui-inline-edit"/>');
  var originalValue = element.val();
  var field = element.attr('name');

  // Display value span
  var displayValue = $('<span class="display-value"/>').text(originalValue);

  // Editable input
  var editableValue = $('<' + editTag + textareaDimensions + ' class="editable"/>').val(originalValue);
  editableValue.addClass('sb-field-control');

  // Confirmation controls
  var newLine  = isInput ? '' : 'inline-edit-textarea';
  var controls = $('<span data-mount="edit-controls"/>').addClass(newLine);
  var cancel   = $('<button/>').addClass('btn btn-default btn-icon').append('<i class="material-icons">close</i>');
  var save     = $('<button/>').addClass('btn btn-primary btn-icon').append('<i class="material-icons">check</i>');

  controls.append(save).append(cancel);

  // Click to edit icon
  var icon = $('<i class="material-icons js-tooltip link_cursor">create</i>');

  // Setup
  parent.append(displayValue).append(icon).append(errors);
  element.replaceWith(parent);
  if (!(_.isUndefined(options)) && options.openByDefault) {
    handleEditClick(icon);
  } else {
    setupEditIcon();
  }

  function setupEditIcon() {
    icon.helpPopover({
      toggle: 'tooltip',
      trigger: 'hover',
      placement: 'top',
      title: 'Edit'
    });

    icon.one('click', function() {
      handleEditClick(this);
    });
  }

  function handleEditClick(icon) {
    $('.tooltip').remove();

    displayValue.replaceWith(editableValue);
    editableValue.focus();
    $(icon).replaceWith(controls);
    addControlClicks();
  }

  function addControlClicks() {
    save.click(function() {
      save.addClass('disabled');
      saveModel();
    });

    cancel.one('click', function() {
      editableValue.val(originalValue);
      switchToView();
    });

    editableValue.one('blur', function(e) {
      var target = $(e.relatedTarget);
      if (target.parents('[data-mount="edit-controls"]').length === 0) {
        switchToView();
      }
    });
  }

  function saveModel() {
    var attrs = Object.keys(model.attributes);

    if (attrs.indexOf(field) >= 0) {
      var data = {};
      data[field] = editableValue.val();
      model.save(data, {
        error: handleError,
        success: onSuccess
      });
    } else {
      ExceptionHandling.logWarning('inlineEdit: "name" attribute on target must match field in model');
    }
  }

  function switchToView() {
    toggleInvalidClass(false);
    setErrors('');

    originalValue = displayValue.text();
    editableValue.replaceWith(displayValue);
    controls.replaceWith(icon);
    setupEditIcon();
    save.removeClass('disabled');
  }

  function handleError() {
    var response = typeof arguments[1] === 'string' ? arguments[0] : arguments[1];
    var errorsText = Ajax.errorMessages(response).join('<br />');

    toggleInvalidClass(true);
    setErrors(errorsText);
    save.removeClass('disabled');
    editableValue.focus();
  }

  function toggleInvalidClass(state) {
    parent.toggleClass('sb-field-group--invalid', state);
  }

  function setErrors(string) {
    errors.html(string);
  }

  function onSuccess(data) {
    if (data && typeof data.get(field) !== 'undefined') {
      displayValue = displayValue.text(data.get(field));
    }
    switchToView();
  }
  return this;
};
